import React from "react";

export interface WithShowProps {
  onClose?: () => void;
  persist?: boolean; // by default, a new instance of modal will rendered every time it's open
  isVisible: boolean;
}

interface HOCChildrenProps {
  show: () => void;
}

export interface WithShowHOCProps {
  children: (props: HOCChildrenProps) => any;
}
export default <P extends WithShowProps>(
    Modal: React.ComponentType<P>
  ): React.ComponentType<Omit<P, "isVisible" | "onClose"> & WithShowHOCProps> =>
  ({ children, persist, ...props }: Omit<P, "isVisible" | "onClose"> & WithShowHOCProps) => {
    const [isVisible, setIsVisible] = React.useState(false);

    const hide = React.useCallback(() => setIsVisible(false), [setIsVisible]);
    const show = React.useCallback(() => setIsVisible(true), [setIsVisible]);

    return (
      <>
        {children({ show })}

        {(persist || isVisible) && <Modal {...(props as unknown as P)} isVisible={isVisible} onClose={hide} />}
      </>
    );
  };
